import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SocketContext as Face2FaceSocketContext } from "../../helpers/contexts/face2face";
import { SocketContext as CommunicationSocketContext } from "../../helpers/contexts/communication";

import Loader from "../Base/Loader";
const Face2FaceLayout = (props) => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const Face2FaceService = useContext(Face2FaceSocketContext);
    const CommunicationService = useContext(CommunicationSocketContext);

    useEffect(() => {
        window.addEventListener('mention-clicked', (e) => {
            navigate(e.value.link)
        })
    }, [])
    useEffect(() => {
        const timerId = setTimeout(() => {
            setLoader(false)
        }, 2000);
        return () => clearTimeout(timerId);
    }, []);

    useEffect(() => {

        if (!Face2FaceService.connected) {
            Face2FaceService.connect();
        }
    }, [Face2FaceService.connected]);
    
    useEffect(() => {

        if (!CommunicationService.connected) {
          CommunicationService.connect();
        }
      }, [CommunicationService.connected]);

    useEffect(() => {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
            window.history.pushState(null, "", window.location.href);
        };
    }, [navigate]);
    
    if (loader) {
        return <Loader />
    }

    return <>{React.cloneElement(props.children)}</>;
};

export default Face2FaceLayout;
